import React from 'react';
import { useActionData } from 'react-router-dom';

import type { ActionResult } from '@oysterjs/core/graphql/actions';
import type { ValidationError } from '@oysterjs/core/graphql';

/**
 * Reads `useActionData()` and returns the validation errors from the most
 * recent action result. Old errors stick until a new submission produces a
 * new set (matching the existing UX across the library edit/create pages);
 * a successful submit that returns no validation errors leaves the previous
 * errors in place until the page re-mounts.
 */
export function useActionValidationErrors<T = unknown>(): ValidationError[] {
  const action = useActionData() as ActionResult<T>;
  const [validationErrors, setValidationErrors] = React.useState<ValidationError[]>([]);
  React.useEffect(() => {
    if (action?.validationErrors) {
      setValidationErrors(action.validationErrors);
    }
  }, [action?.validationErrors]);
  return validationErrors;
}
